import { request } from "../helpers/axios.new";

export const GET_COMPANY_GOAL = () => {
  return request({
    url: `/company-goal`,
    method: "GET",
  });
};

export const SAVE_COMPANY_GOAL = (payload) => {
  return request({
    url: `/company-goal`,
    method: "PUT",
    data: payload,
  });
};

export const DELETE_COMPANY_GOAL = () => {
  return request({
    url: `/company-goal`,
    method: "DELETE",
  });
};

export const UPLOAD_COMPANY_GOAL_MOUNTAIN_IMAGE = (formData) =>
  request({
    method: "PUT",
    url: "/company-goal/mountain-image",
    data: formData,
  });

export const DELETE_COMPANY_GOAL_MOUNTAIN_IMAGE = () =>
  request({
    method: "DELETE",
    url: "/company-goal/mountain-image",
  });
